export default "__VITE_PUBLIC_ASSET__7f5123c1__"